import {DomainObject} from 'shared/DomainObject';
import {observable} from 'mobx';

class Department extends DomainObject {
  @observable id;
  @observable name;

  static defaultOrderAttribute() {
    return 'name';
  }
}

export default Department;

